export const isActiveElementPopover = () => document.activeElement.dataset.componentName === "PopoverContent";
